(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7650,8578],{

/***/ 44133:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst


  var envHasBigInt64Array = typeof BigInt64Array !== 'undefined';


module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 86628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Ot; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
function e(){return(e=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}const n=(/* unused pure expression or super */ null && (["children","options"])),r=["allowFullScreen","allowTransparency","autoComplete","autoFocus","autoPlay","cellPadding","cellSpacing","charSet","className","classId","colSpan","contentEditable","contextMenu","crossOrigin","encType","formAction","formEncType","formMethod","formNoValidate","formTarget","frameBorder","hrefLang","inputMode","keyParams","keyType","marginHeight","marginWidth","maxLength","mediaGroup","minLength","noValidate","radioGroup","readOnly","rowSpan","spellCheck","srcDoc","srcLang","srcSet","tabIndex","useMap"].reduce((t,e)=>(t[e.toLowerCase()]=e,t),{for:"htmlFor"}),o={amp:"&",apos:"'",gt:">",lt:"<",nbsp:" ",quot:"“"},c=["style","script"],a=/([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,u=/mailto:/i,i=/\n{2,}$/,l=/^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,s=/^ *> ?/gm,_=/^ {2,}\n/,f=/^(?:( *[-*_]) *){3,}(?:\n *)+\n/,d=/^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,p=/^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,g=/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,m=/^(?:\n *)*\n/,y=/\r\n?/g,h=/^\[\^([^\]]+)](:.*)\n/,k=/^\[\^([^\]]+)]/,x=/\f/g,b=/^\s*?\[(x|\s)\]/,v=/^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,S=/^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,$=/^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,w=/&([a-z]+);/g,z=/^<!--[\s\S]*?(?:-->)/,E=/^(data|aria|x)-[a-z_][a-z\d_.-]*$/,A=/^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,R=/^\{.*\}$/,I=/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,M=/^<([^ >]+@[^ >]+)>/,O=/^<([^ >]+:\/[^ >]+)>/,B=/ *\n+$/,L=/(?:^|\n)( *)$/,T=/-([a-z])?/gi,j=/^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,C=/^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,D=/^!\[([^\]]*)\] ?\[([^\]]*)\]/,N=/^\[([^\]]*)\] ?\[([^\]]*)\]/,Z=/(\[|\])/g,F=/(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,P=/\t/g,G=/^ *\| */,H=/(^ *\||\| *$)/g,q=/ *$/,U=/^ *:-+: *$/,V=/^ *:-+ *$/,W=/^ *-+: *$/,Q=/^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,X=/^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/,J=/^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,K=/^\\([^0-9A-Za-z\s])/,Y=/^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,tt=/^\n+/,et=/^([ \t]*)/,nt=/\\([^0-9A-Z\s])/gi,rt=new RegExp("^( *)((?:[*+-]|\\d+\\.)) +"),ot=new RegExp("^( *)((?:[*+-]|\\d+\\.)) +[^\\n]*(?:\\n(?!\\1(?:[*+-]|\\d+\\.) )[^\\n]*)*(\\n|$)","gm"),ct=new RegExp("^( *)((?:[*+-]|\\d+\\.)) [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1(?:[*+-]|\\d+\\.) (?!(?:[*+-]|\\d+\\.) ))\\n*|\\s*\\n*$)"),at="(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*",ut=new RegExp("^\\[("+at+")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),it=new RegExp("^!\\[("+at+")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),lt=[l,p,d,v,S,z,ot,ct,j],st=[...lt,/^[^\n]+(?:  \n|\n{2,})/,$,A];function _t(t){return t.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g,"a").replace(/[çÇ]/g,"c").replace(/[ðÐ]/g,"d").replace(/[ÈÉÊËéèêë]/g,"e").replace(/[ÏïÎîÍíÌì]/g,"i").replace(/[Ññ]/g,"n").replace(/[øØœŒÕõÔôÓóÒò]/g,"o").replace(/[ÜüÛûÚúÙù]/g,"u").replace(/[ŸÿÝý]/g,"y").replace(/[^a-z0-9- ]/gi,"").replace(/ /gi,"-").toLowerCase()}function ft(t){return W.test(t)?"right":U.test(t)?"center":V.test(t)?"left":null}function dt(t,e,n){const r=n.t;n.t=!0;const o=e(t.trim(),n);n.t=r;let c=[[]];return o.forEach(function(t,e){"tableSeparator"===t.type?0!==e&&e!==o.length-1&&c.push([]):("text"!==t.type||null!=o[e+1]&&"tableSeparator"!==o[e+1].type||(t.content=t.content.replace(q,"")),c[c.length-1].push(t))}),c}function pt(t,e,n){n.o=!0;const r=dt(t[1],e,n),o=t[2].replace(H,"").split("|").map(ft),c=function(t,e,n){return t.trim().split("\n").map(function(t){return dt(t,e,n)})}(t[3],e,n);return n.o=!1,{align:o,cells:c,header:r,type:"table"}}function gt(t,e){return null==t.align[e]?{}:{textAlign:t.align[e]}}function mt(t){return function(e,n){return n.o?t.exec(e):null}}function yt(t){return function(e,n){return n.o||n.u?t.exec(e):null}}function ht(t){return function(e,n){return n.o||n.u?null:t.exec(e)}}function kt(t){return function(e){return t.exec(e)}}function xt(t,e,n){if(e.o||e.u)return null;if(n&&!n.endsWith("\n"))return null;let r="";t.split("\n").every(t=>!lt.some(e=>e.test(t))&&(r+=t+"\n",t.trim()));const o=r.trimEnd();return""==o?null:[r,o]}function bt(t){try{if(decodeURIComponent(t).replace(/[^A-Za-z0-9/:]/g,"").match(/^\s*(javascript|vbscript|data):/i))return null}catch(t){return null}return t}function vt(t){return t.replace(nt,"$1")}function St(t,e,n){const r=n.o||!1,o=n.u||!1;n.o=!0,n.u=!0;const c=t(e,n);return n.o=r,n.u=o,c}function $t(t,e,n){const r=n.o||!1,o=n.u||!1;n.o=!1,n.u=!0;const c=t(e,n);return n.o=r,n.u=o,c}function wt(t,e,n){return n.o=!1,t(e+"\n\n",n)}const zt=(t,e,n)=>({content:St(e,t[1],n)});function Et(){return{}}function At(){return null}function Rt(...t){return t.filter(Boolean).join(" ")}function It(t,e,n){let r=t;const o=e.split(".");for(;o.length&&(r=r[o[0]],void 0!==r);)o.shift();return r||n}var Mt;function Ot(n,H={}){H.overrides=H.overrides||{},H.slugify=H.slugify||_t,H.namedCodesToUnicode=H.namedCodesToUnicode?e({},o,H.namedCodesToUnicode):o;const q=H.createElement||react__WEBPACK_IMPORTED_MODULE_0__.createElement;function U(t,n,...r){const o=It(H.overrides,`${t}.props`,{});return q(function(t,e){const n=It(e,t);return n?"function"==typeof n||"object"==typeof n&&"render"in n?n:It(e,`${t}.component`,t):t}(t,H.overrides),e({},n,o,{className:Rt(null==n?void 0:n.className,o.className)||void 0}),...r)}function V(e){let n=!1;H.forceInline?n=!0:H.forceBlock||(n=!1===F.test(e));const r=dt(ft(n?e:`${e.trimEnd().replace(tt,"")}\n\n`,{o:n}));for(;"string"==typeof r[r.length-1]&&!r[r.length-1].trim();)r.pop();if(null===H.wrapper)return r;const o=H.wrapper||(n?"span":"div");let c;if(r.length>1||H.forceWrapper)c=r;else{if(1===r.length)return c=r[0],"string"==typeof c?U("span",{key:"outer"},c):c;c=null}return react__WEBPACK_IMPORTED_MODULE_0__.createElement(o,{key:"outer"},c)}function W(e){const n=e.match(a);return n?n.reduce(function(e,n,o){const c=n.indexOf("=");if(-1!==c){const a=function(t){return-1!==t.indexOf("-")&&null===t.match(E)&&(t=t.replace(T,function(t,e){return e.toUpperCase()})),t}(n.slice(0,c)).trim(),u=function(t){const e=t[0];return('"'===e||"'"===e)&&t.length>=2&&t[t.length-1]===e?t.slice(1,-1):t}(n.slice(c+1).trim()),i=r[a]||a,l=e[i]=function(t,e){return"style"===t?e.split(/;\s?/).reduce(function(t,e){const n=e.slice(0,e.indexOf(":"));return t[n.replace(/(-[a-z])/g,t=>t[1].toUpperCase())]=e.slice(n.length+1).trim(),t},{}):"href"===t?bt(e):(e.match(R)&&(e=e.slice(1,e.length-1)),"true"===e||"false"!==e&&e)}(a,u);"string"==typeof l&&($.test(l)||A.test(l))&&(e[i]=react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(V(l.trim()),{key:o}))}else"style"!==n&&(e[r[n]||n]=!0);return e},{}):void 0}const nt=[],at={},lt={blockQuote:{i:ht(l),l:Mt.HIGH,_:(t,e,n)=>({content:e(t[0].replace(s,""),n)}),p:(t,e,n)=>U("blockquote",{key:n.g},e(t.content,n))},breakLine:{i:kt(_),l:Mt.HIGH,_:Et,p:(t,e,n)=>U("br",{key:n.g})},breakThematic:{i:ht(f),l:Mt.HIGH,_:Et,p:(t,e,n)=>U("hr",{key:n.g})},codeBlock:{i:ht(p),l:Mt.MAX,_:t=>({content:t[0].replace(/^ {4}/gm,"").replace(/\n+$/,""),lang:void 0}),p:(t,e,n)=>U("pre",{key:n.g},U("code",{className:t.lang?`lang-${t.lang}`:""},t.content))},codeFenced:{i:ht(d),l:Mt.MAX,_:t=>({content:t[3],lang:t[2]||void 0,type:"codeBlock"})},codeInline:{i:yt(g),l:Mt.LOW,_:t=>({content:t[2]}),p:(t,e,n)=>U("code",{key:n.g},t.content)},footnote:{i:ht(h),l:Mt.MAX,_:t=>(nt.push({footnote:t[2],identifier:t[1]}),{}),p:At},footnoteReference:{i:mt(k),l:Mt.HIGH,_:t=>({content:t[1],target:`#${H.slugify(t[1])}`}),p:(t,e,n)=>U("a",{key:n.g,href:bt(t.target)},U("sup",{key:n.g},t.content))},gfmTask:{i:mt(b),l:Mt.HIGH,_:t=>({completed:"x"===t[1].toLowerCase()}),p:(t,e,n)=>U("input",{checked:t.completed,key:n.g,readOnly:!0,type:"checkbox"})},heading:{i:ht(v),l:Mt.HIGH,_:(t,e,n)=>({content:St(e,t[2],n),id:H.slugify(t[2]),level:t[1].length}),p:(t,e,n)=>(t.tag=`h${t.level}`,U(t.tag,{id:t.id,key:n.g},e(t.content,n)))},headingSetext:{i:ht(S),l:Mt.MAX,_:(t,e,n)=>({content:St(e,t[1],n),level:"="===t[2]?1:2,type:"heading"})},htmlComment:{i:kt(z),l:Mt.HIGH,_:()=>({}),p:At},image:{i:yt(it),l:Mt.HIGH,_:t=>({alt:t[1],target:vt(t[2]),title:t[3]}),p:(t,e,n)=>U("img",{key:n.g,alt:t.alt||void 0,title:t.title||void 0,src:bt(t.target)})},link:{i:mt(ut),l:Mt.LOW,_:(t,e,n)=>({content:$t(e,t[1],n),target:vt(t[2]),title:t[3]}),p:(t,e,n)=>U("a",{key:n.g,href:bt(t.target),title:t.title},e(t.content,n))},linkAngleBraceStyleDetector:{i:mt(O),l:Mt.MAX,_:t=>({content:[{content:t[1],type:"text"}],target:t[1],type:"link"})},linkBareUrlDetector:{i:(t,e)=>e.m?null:mt(I)(t,e),l:Mt.MAX,_:t=>({content:[{content:t[1],type:"text"}],target:t[1],title:void 0,type:"link"})},linkMailtoDetector:{i:mt(M),l:Mt.MAX,_(t){let e=t[1],n=t[1];return u.test(n)||(n="mailto:"+n),{content:[{content:e.replace("mailto:",""),type:"text"}],target:n,type:"link"}}},list:{i(t,e,n){const r=L.exec(n);return!r||!e.h&&e.o?null:ct.exec(t=r[1]+t)},l:Mt.HIGH,_(t,e,n){const r=t[2],o=r.length>1,c=o?+r:void 0,a=t[0].replace(i,"\n").match(ot);let u=!1;return{items:a.map(function(t,r){const o=rt.exec(t)[0].length,c=new RegExp("^ {1,"+o+"}","gm"),i=t.replace(c,"").replace(rt,""),l=r===a.length-1,s=-1!==i.indexOf("\n\n")||l&&u;u=s;const _=n.o,f=n.h;let d;n.h=!0,s?(n.o=!1,d=i.replace(B,"\n\n")):(n.o=!0,d=i.replace(B,""));const p=e(d,n);return n.o=_,n.h=f,p}),ordered:o,start:c}},p:(t,e,n)=>U(t.ordered?"ol":"ul",{key:n.g,start:t.start},t.items.map(function(t,r){return U("li",{key:r},e(t,n))}))},newlineCoalescer:{i:ht(m),l:Mt.LOW,_:Et,p:()=>"\n"},paragraph:{i:xt,l:Mt.LOW,_:zt,p:(t,e,n)=>U("p",{key:n.g},e(t.content,n))},ref:{i:mt(C),l:Mt.MAX,_:t=>(at[t[1]]={target:t[2],title:t[4]},{}),p:At},refImage:{i:yt(D),l:Mt.MAX,_:t=>({alt:t[1]||void 0,ref:t[2]}),p:(t,e,n)=>U("img",{key:n.g,alt:t.alt,src:bt(at[t.ref].target),title:at[t.ref].title})},refLink:{i:mt(N),l:Mt.MAX,_:(t,e,n)=>({content:e(t[1],n),fallbackContent:e(t[0].replace(Z,"\\$1"),n),ref:t[2]}),p:(t,e,n)=>at[t.ref]?U("a",{key:n.g,href:bt(at[t.ref].target),title:at[t.ref].title},e(t.content,n)):U("span",{key:n.g},e(t.fallbackContent,n))},table:{i:ht(j),l:Mt.HIGH,_:pt,p:(t,e,n)=>U("table",{key:n.g},U("thead",null,U("tr",null,t.header.map(function(r,o){return U("th",{key:o,style:gt(t,o)},e(r,n))}))),U("tbody",null,t.cells.map(function(r,o){return U("tr",{key:o},r.map(function(r,o){return U("td",{key:o,style:gt(t,o)},e(r,n))}))})))},tableSeparator:{i:function(t,e){return e.t?G.exec(t):null},l:Mt.HIGH,_:function(){return{type:"tableSeparator"}},p:()=>" | "},text:{i:kt(Y),l:Mt.MIN,_:t=>({content:t[0].replace(w,(t,e)=>H.namedCodesToUnicode[e]?H.namedCodesToUnicode[e]:t)}),p:t=>t.content},textBolded:{i:yt(Q),l:Mt.MED,_:(t,e,n)=>({content:e(t[2],n)}),p:(t,e,n)=>U("strong",{key:n.g},e(t.content,n))},textEmphasized:{i:yt(X),l:Mt.LOW,_:(t,e,n)=>({content:e(t[2],n)}),p:(t,e,n)=>U("em",{key:n.g},e(t.content,n))},textEscaped:{i:yt(K),l:Mt.HIGH,_:t=>({content:t[1],type:"text"})},textStrikethroughed:{i:yt(J),l:Mt.LOW,_:zt,p:(t,e,n)=>U("del",{key:n.g},e(t.content,n))}};!0!==H.disableParsingRawHTML&&(lt.htmlBlock={i:kt($),l:Mt.HIGH,_(t,e,n){const[,r]=t[3].match(et),o=new RegExp(`^${r}`,"gm"),a=t[3].replace(o,""),u=(i=a,st.some(t=>t.test(i))?wt:St);var i;const l=t[1].toLowerCase(),s=-1!==c.indexOf(l);n.m=n.m||"a"===l;const _=s?t[3]:u(e,a,n);return n.m=!1,{attrs:W(t[2]),content:_,noInnerParse:s,tag:s?l:t[1]}},p:(t,n,r)=>U(t.tag,e({key:r.g},t.attrs),t.noInnerParse?t.content:n(t.content,r))},lt.htmlSelfClosing={i:kt(A),l:Mt.HIGH,_:t=>({attrs:W(t[2]||""),tag:t[1]}),p:(t,n,r)=>U(t.tag,e({},t.attrs,{key:r.g}))});const ft=function(t){let e=Object.keys(t);function n(r,o){let c=[],a="";for(;r;){let u=0;for(;u<e.length;){const i=e[u],l=t[i],s=l.i(r,o,a);if(s){const t=s[0];r=r.substring(t.length);const e=l._(s,n,o);null==e.type&&(e.type=i),c.push(e),a=t;break}u++}}return c}return e.sort(function(e,n){let r=t[e].l,o=t[n].l;return r!==o?r-o:e<n?-1:1}),function(t,e){return n(function(t){return t.replace(y,"\n").replace(x,"").replace(P,"    ")}(t),e)}}(lt),dt=(Ot=function(t){return function(e,n,r){return t[e.type].p(e,n,r)}}(lt),function t(e,n={}){if(Array.isArray(e)){const r=n.g,o=[];let c=!1;for(let r=0;r<e.length;r++){n.g=r;const a=t(e[r],n),u="string"==typeof a;u&&c?o[o.length-1]+=a:null!==a&&o.push(a),c=u}return n.g=r,o}return Ot(e,t,n)});var Ot;const Bt=V(n);return nt.length?U("div",null,Bt,U("footer",{key:"footer"},nt.map(function(t){return U("div",{id:H.slugify(t.identifier),key:t.identifier},t.identifier,dt(ft(t.footnote,{o:!0})))}))):Bt}!function(t){t[t.MAX=0]="MAX",t[t.HIGH=1]="HIGH",t[t.MED=2]="MED",t[t.LOW=3]="LOW",t[t.MIN=4]="MIN"}(Mt||(Mt={}));/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (e=>{let{children:r,options:o}=e,c=function(t,e){if(null==t)return{};var n,r,o={},c=Object.keys(t);for(r=0;r<c.length;r++)e.indexOf(n=c[r])>=0||(o[n]=t[n]);return o}(e,n);return t.cloneElement(Ot(r,o),c)});
//# sourceMappingURL=index.modern.js.map


/***/ }),

/***/ 96808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ useSwipeable; }
/* harmony export */ });
/* unused harmony exports DOWN, LEFT, RIGHT, UP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);


const LEFT = "Left";
const RIGHT = "Right";
const UP = "Up";
const DOWN = "Down";

/* global document */
const defaultProps = {
    delta: 10,
    preventScrollOnSwipe: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true,
    swipeDuration: Infinity,
    touchEventOptions: { passive: true },
};
const initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0],
};
const mouseMove = "mousemove";
const mouseUp = "mouseup";
const touchEnd = "touchend";
const touchMove = "touchmove";
const touchStart = "touchstart";
function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
        if (deltaX > 0) {
            return RIGHT;
        }
        return LEFT;
    }
    else if (deltaY > 0) {
        return DOWN;
    }
    return UP;
}
function rotateXYByAngle(pos, angle) {
    if (angle === 0)
        return pos;
    const angleInRadians = (Math.PI / 180) * angle;
    const x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    const y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
}
function getHandlers(set, handlerProps) {
    const onStart = (event) => {
        const isTouch = "touches" in event;
        // if more than a single touch don't track, for now...
        if (isTouch && event.touches.length > 1)
            return;
        set((state, props) => {
            // setup mouse listeners on document to track swipe since swipe can leave container
            if (props.trackMouse && !isTouch) {
                document.addEventListener(mouseMove, onMove);
                document.addEventListener(mouseUp, onUp);
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            props.onTouchStartOrOnMouseDown &&
                props.onTouchStartOrOnMouseDown({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { initial: xy.slice(), xy, start: event.timeStamp || 0 });
        });
    };
    const onMove = (event) => {
        set((state, props) => {
            const isTouch = "touches" in event;
            // Discount a swipe if additional touches are present after
            // a swipe has started.
            if (isTouch && event.touches.length > 1) {
                return state;
            }
            // if swipe has exceeded duration stop tracking
            if (event.timeStamp - state.start > props.swipeDuration) {
                return state.swiping ? Object.assign(Object.assign({}, state), { swiping: false }) : state;
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const [x, y] = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            const deltaX = x - state.xy[0];
            const deltaY = y - state.xy[1];
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            const time = (event.timeStamp || 0) - state.start;
            const velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
            const vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
            const dir = getDirection(absX, absY, deltaX, deltaY);
            // if swipe is under delta and we have not started to track a swipe: skip update
            const delta = typeof props.delta === "number"
                ? props.delta
                : props.delta[dir.toLowerCase()] ||
                    defaultProps.delta;
            if (absX < delta && absY < delta && !state.swiping)
                return state;
            const eventData = {
                absX,
                absY,
                deltaX,
                deltaY,
                dir,
                event,
                first: state.first,
                initial: state.initial,
                velocity,
                vxvy,
            };
            // call onSwipeStart if present and is first swipe event
            eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
            // call onSwiping if present
            props.onSwiping && props.onSwiping(eventData);
            // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
            // so we can call preventDefault if needed
            let cancelablePageSwipe = false;
            if (props.onSwiping ||
                props.onSwiped ||
                props[`onSwiped${dir}`]) {
                cancelablePageSwipe = true;
            }
            if (cancelablePageSwipe &&
                props.preventScrollOnSwipe &&
                props.trackTouch &&
                event.cancelable) {
                event.preventDefault();
            }
            return Object.assign(Object.assign({}, state), { 
                // first is now always false
                first: false, eventData, swiping: true });
        });
    };
    const onEnd = (event) => {
        set((state, props) => {
            let eventData;
            if (state.swiping && state.eventData) {
                // if swipe is less than duration fire swiped callbacks
                if (event.timeStamp - state.start < props.swipeDuration) {
                    eventData = Object.assign(Object.assign({}, state.eventData), { event });
                    props.onSwiped && props.onSwiped(eventData);
                    const onSwipedDir = props[`onSwiped${eventData.dir}`];
                    onSwipedDir && onSwipedDir(eventData);
                }
            }
            else {
                props.onTap && props.onTap({ event });
            }
            props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { eventData });
        });
    };
    const cleanUpMouse = () => {
        // safe to just call removeEventListener
        document.removeEventListener(mouseMove, onMove);
        document.removeEventListener(mouseUp, onUp);
    };
    const onUp = (e) => {
        cleanUpMouse();
        onEnd(e);
    };
    /**
     * The value of passive on touchMove depends on `preventScrollOnSwipe`:
     * - true => { passive: false }
     * - false => { passive: true } // Default
     *
     * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
     *
     * props.touchEventOptions can also be set for all touch event listeners,
     * but for `touchmove` specifically when `preventScrollOnSwipe` it will
     * supersede and force passive to false.
     *
     */
    const attachTouch = (el, props) => {
        let cleanup = () => { };
        if (el && el.addEventListener) {
            const baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions);
            // attach touch event listeners and handlers
            const tls = [
                [touchStart, onStart, baseOptions],
                // preventScrollOnSwipe option supersedes touchEventOptions.passive
                [
                    touchMove,
                    onMove,
                    Object.assign(Object.assign({}, baseOptions), (props.preventScrollOnSwipe ? { passive: false } : {})),
                ],
                [touchEnd, onEnd, baseOptions],
            ];
            tls.forEach(([e, h, o]) => el.addEventListener(e, h, o));
            // return properly scoped cleanup method for removing listeners, options not required
            cleanup = () => tls.forEach(([e, h]) => el.removeEventListener(e, h));
        }
        return cleanup;
    };
    const onRef = (el) => {
        // "inline" ref functions are called twice on render, once with null then again with DOM element
        // ignore null here
        if (el === null)
            return;
        set((state, props) => {
            // if the same DOM el as previous just return state
            if (state.el === el)
                return state;
            const addState = {};
            // if new DOM el clean up old DOM and reset cleanUpTouch
            if (state.el && state.el !== el && state.cleanUpTouch) {
                state.cleanUpTouch();
                addState.cleanUpTouch = void 0;
            }
            // only attach if we want to track touch
            if (props.trackTouch && el) {
                addState.cleanUpTouch = attachTouch(el, props);
            }
            // store event attached DOM el for comparison, clean up, and re-attachment
            return Object.assign(Object.assign(Object.assign({}, state), { el }), addState);
        });
    };
    // set ref callback to attach touch event listeners
    const output = {
        ref: onRef,
    };
    // if track mouse attach mouse down listener
    if (handlerProps.trackMouse) {
        output.onMouseDown = onStart;
    }
    return [output, attachTouch];
}
function updateTransientState(state, props, previousProps, attachTouch) {
    // if trackTouch is off or there is no el, then remove handlers if necessary and exit
    if (!props.trackTouch || !state.el) {
        if (state.cleanUpTouch) {
            state.cleanUpTouch();
        }
        return Object.assign(Object.assign({}, state), { cleanUpTouch: undefined });
    }
    // trackTouch is on, so if there are no handlers attached, attach them and exit
    if (!state.cleanUpTouch) {
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
    // remove and reattach handlers (this is required to update the passive option when attaching
    // the handlers)
    if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe ||
        props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
        state.cleanUpTouch();
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    return state;
}
function useSwipeable(options) {
    const { trackMouse } = options;
    const transientState = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, initialState));
    const transientProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, defaultProps));
    // track previous rendered props
    const previousProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, transientProps.current));
    previousProps.current = Object.assign({}, transientProps.current);
    // update current render props & defaults
    transientProps.current = Object.assign(Object.assign({}, defaultProps), options);
    // Force defaults for config properties
    let defaultKey;
    for (defaultKey in defaultProps) {
        if (transientProps.current[defaultKey] === void 0) {
            transientProps.current[defaultKey] = defaultProps[defaultKey];
        }
    }
    const [handlers, attachTouch] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => getHandlers((stateSetter) => (transientState.current = stateSetter(transientState.current, transientProps.current)), { trackMouse }), [trackMouse]);
    transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
    return handlers;
}


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 52825:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carbon-for-campus",
      function () {
        return __webpack_require__(46287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ImageItemList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _components_NextImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5621);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);




const ImageItem = (param)=>{
    let { header , content , image , className , step  } = param;
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: "mb16 mb10-md ph4 ph0-md ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NextImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: image.src,
                height: image.height,
                width: image.height,
                alt: ""
            }),
            Number.isInteger(step) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "darkGreen ttu font-im",
                children: i18n.t("Step {{number}}", {
                    number: step
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-cm fs28 fs20-md lh12 mt2 mb3 mb1-md gray800 maxw18-md",
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "lh14 fs16-md font-ir gray600 maxw25 maxw16-md",
                children: content
            })
        ]
    });
};
const ImageItemList = (param)=>/*#__PURE__*/ {
    let { items , rows =1 , itemClassName ="" , showSteps =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "df jcsb fdc-md ".concat(rows > 1 && "fw"),
        children: items.map((item, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageItem, {
                // @ts-expect-error TS2322: Type 'number | false' is not assignable to type 'number | undefined'.
                step: showSteps && key + 1,
                ...item,
                className: "".concat(itemClassName, " ").concat(rows === 2 && "w50p w100p-md")
            }, key))
    });
};


/***/ }),

/***/ 46452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ IllustratedTextDecoration; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52299);



const IllustratedTextDecoration = (param)=>/*#__PURE__*/ {
    let { type , style , className , width ="100%" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_useV5ImgSrc__WEBPACK_IMPORTED_MODULE_2__/* .V5Image */ .dZ, {
        style: {
            bottom: type === "circle" ? 1 : -14,
            ...style
        },
        src: "home/word-".concat(type),
        imgExt: "webp",
        className: "pos-a-center right0 left0 ma maxw-none zIndex-1 ".concat(className),
        width: width,
        ...props,
        alt: ""
    });
};


/***/ }),

/***/ 35049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ required; },
/* harmony export */   "Pk": function() { return /* binding */ requireEmail; },
/* harmony export */   "Y0": function() { return /* binding */ validatePhoneNumber; },
/* harmony export */   "qS": function() { return /* binding */ validateDate; }
/* harmony export */ });
/* harmony import */ var awesome_phonenumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63743);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50995);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75314);
/* harmony import */ var validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2__);



/**
 * Validator which requires a non-empty input.
 */ const required = (msg)=>(input)=>{
        if (!input) {
            if (msg) {
                return msg;
            }
            return "";
        }
        return undefined;
    };
const requireEmail = (msg)=>(input)=>{
        if (!validator_lib_isEmail__WEBPACK_IMPORTED_MODULE_2___default()(input)) {
            return msg;
        }
        return undefined;
    };
const validateDate = (msgs)=>(input)=>{
        if (!input) {
            if (!msgs) return "";
            return msgs[0];
        }
        const date = moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(input, "MM/DD/YYYY", true);
        const dateNow = moment_timezone__WEBPACK_IMPORTED_MODULE_1___default()(new Date());
        if (!date.isValid()) {
            if (!msgs) return "";
            return msgs[1];
        }
        if (date.isAfter(dateNow)) {
            if (!msgs) return "";
            return msgs[2];
        }
        return undefined;
    };
const validatePhoneNumber = (msg)=>(num, regionSlug)=>{
        if (num && typeof num === "string") {
            const phoneNum = (0,awesome_phonenumber__WEBPACK_IMPORTED_MODULE_0__/* .parsePhoneNumber */ .SR)(num, regionSlug);
            const isValid = phoneNum.isValid();
            if (!isValid) {
                return msg;
            }
            return undefined;
        }
    };


/***/ }),

/***/ 29414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Salesforce_SalesforceForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/components/v5/Input/utils/Validators.ts
var Validators = __webpack_require__(35049);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/components/v5/Transitions/Fade.tsx
var Fade = __webpack_require__(64800);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/Salesforce/SalesforceFormSuccess.tsx







const SalesforceFormSuccess = (param)=>{
    let { error , setSubmitStatus  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { imgExt  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const header = error ? i18n.t("Something went wrong.") : i18n.t("Thank you!");
    const text = error ? i18n.t("Thank you for your patience! Please try again.") : i18n.t("We’ll get back to you within one business day. In the meantime, explore employer resources from our Chief Medical Officer Sujal Mandavia.");
    const resetSubmitStatus = ()=>{
        setSubmitStatus("not-submitted");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pos-r oh p8 pb40 pb30-xs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fade/* default */.Z, {
                in: true,
                appear: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fs28 fs32-sm font-cb mb4",
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "fs24 fs24-sm font-cm gray800 ",
                        children: text
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                        "aria-label": i18n.t("Click to go back to the submission form and try again."),
                        className: "mt8 focus-bsDarkBlue3 event-Yd9g9c mr1",
                        onClick: resetSubmitStatus,
                        children: i18n.t("Go Back")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(V5Comp/* Btn */.un, {
                        className: "focus-bsDarkBlue3 mt8",
                        href: "https://www.youtube.com/playlist?list=PLu-GZsDFusNbZFeTN8m7RNOtGu5n7Yv4g",
                        children: [
                            i18n.t("Watch the Playlist"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-arrow-45deg fs10 ml3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
                src: "/illustrations/squiggly-lines-yellow-2.".concat(imgExt),
                className: "pos-a bottom0 right0"
            })
        ]
    });
};
/* harmony default export */ var Salesforce_SalesforceFormSuccess = (SalesforceFormSuccess);

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(62276);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__(75314);
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);
// EXTERNAL MODULE: ./src/components/v5/Input/TextInput.tsx
var TextInput = __webpack_require__(85208);
;// CONCATENATED MODULE: ./src/components/v5/Salesforce/SalesforceForm.tsx















const initialFormState = {
    firstName: _constants/* dev */.WI ? "carbon" : "",
    lastName: _constants/* dev */.WI ? "eng" : "",
    title: _constants/* dev */.WI ? "eng" : "",
    company: _constants/* dev */.WI ? "carbon" : "",
    email: _constants/* dev */.WI ? "eng@carbonhealth.com" : ""
};
const initialFormValidationState = {
    firstName: false,
    lastName: false,
    title: false,
    company: false,
    email: false
};
const SalesforceForm = (param)=>{
    let { trackingCategory ="" , trackingAction ="Lead Form" , companyFieldLabel , channel ="" , submitButtonLabel , emailFieldLabel , titleFieldLabel , excludedFields =[]  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [formState, setFormState] = (0,react.useState)(initialFormState);
    const [formValidationState, setFormValidationState] = (0,react.useState)(initialFormValidationState);
    const [submitStatus, setSubmitStatus] = (0,react.useState)("not-submitted");
    // @ts-expect-error TS2345: Argument of type 'null' is not assignable to parameter of type 'number | (() => number)'.
    const [linkedInConversionId, setLinkedInConversionId] = (0,react.useState)(null);
    const { recaptchaClientKey , csrfToken  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const recaptchaRef = (0,react.useRef)(null);
    const updateFormState = (key)=>(val)=>{
            setFormState({
                ...formState,
                [key]: val
            });
        };
    const updateFormValidationState = (key)=>(val)=>{
            setFormValidationState({
                ...formValidationState,
                [key]: val
            });
        };
    const onError = ()=>{
        setSubmitStatus("error");
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (isSubmitDisabled) {
            return;
        }
        setSubmitStatus("submitted");
        // @ts-expect-error TS2531: Object is possibly 'null'.
        const captcha = await recaptchaRef.current.executeAsync();
        (0,api/* addToSalesforce */.u)(csrfToken, {
            FirstName: formState.firstName,
            LastName: formState.lastName,
            Title: formState.title,
            Email: formState.email,
            Company: formState.company,
            LeadSource: "web",
            channel__c: channel,
            captcha
        }).then(()=>{
            (0,Carbon/* trackToPatient */.Zr)({
                ga: {
                    category: trackingCategory,
                    action: trackingAction,
                    label: formState.company
                }
            });
            setLinkedInConversionId(_constants/* c4BLinkedInConversionId */.et);
            setSubmitStatus("success");
            setTimeout(()=>{
                setSubmitStatus("not-submitted");
            }, 15000);
        }).catch(()=>{
            onError();
        });
    };
    const isFormValid = !formState.omit("title").vals().map((val)=>Boolean(val)).includes(false) && isEmail_default()(formState.email);
    const isSubmitDisabled = submitStatus === "submitted" || submitStatus === "error" || !isFormValid;
    const fields = (0,react.useMemo)(()=>{
        return [
            {
                name: "firstName",
                label: i18n.t("First Name"),
                className: "w50p-f pr2 w100p-f-sm pr0-sm",
                defaultValue: initialFormState.firstName,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.firstName) ? (0,Validators/* required */.C1)()(formState.firstName) : undefined
            },
            {
                name: "lastName",
                label: i18n.t("Last Name"),
                className: "w50p-f pl2 w100p-f-sm pl0-sm",
                defaultValue: initialFormState.lastName,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.lastName) ? (0,Validators/* required */.C1)()(formState.lastName) : undefined
            },
            {
                name: "title",
                label: titleFieldLabel || i18n.t("Your title / position"),
                defaultValue: initialFormState.title,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.title) ? (0,Validators/* required */.C1)()(formState.title) : undefined
            },
            {
                name: "company",
                label: companyFieldLabel || i18n.t("Company name"),
                defaultValue: initialFormState.company,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.company) ? (0,Validators/* required */.C1)()(formState.company) : undefined
            },
            {
                name: "email",
                label: emailFieldLabel || i18n.t("Business email address"),
                defaultValue: initialFormState.email,
                errorMsg: (formValidationState === null || formValidationState === void 0 ? void 0 : formValidationState.email) ? (0,Validators/* required */.C1)()(formState.email) : undefined
            }
        ];
    }, [
        formValidationState,
        formState,
        companyFieldLabel,
        emailFieldLabel,
        titleFieldLabel,
        i18n
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white br1 minw32 minw0-sm maxw32",
        children: [
            submitStatus === "success" || submitStatus === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Salesforce_SalesforceFormSuccess, {
                error: submitStatus === "error",
                setSubmitStatus: setSubmitStatus
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p8 p4-md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    id: "salesforce-form",
                    className: "df fdc",
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: fields.map((param)=>{
                                let { name , label , defaultValue , className , errorMsg  } = param;
                                return !excludedFields.includes(name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fl mb4 w100p ".concat(className),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                        label: "".concat(i18n.t(label), " * "),
                                        onChange: updateFormState(name),
                                        defaultValue: defaultValue,
                                        errorMsg: errorMsg,
                                        setValidation: updateFormValidationState(name)
                                    })
                                }, name);
                            })
                        }),
                        submitStatus === "submitted" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            duration: 100,
                            in: true,
                            appear: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fs20 font-cb lh17 mv3",
                                children: i18n.t("Saving your form...")
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            "aria-label": i18n.t("Click to submit the form."),
                            className: "focus-bsDarkBlue3 t-100 event-d2ybCl",
                            bg: isSubmitDisabled ? palette.gray100 : palette.darkerYellow,
                            color: isSubmitDisabled ? palette.gray400 : "#fff",
                            type: "submit",
                            disabled: isSubmitDisabled,
                            children: submitButtonLabel || i18n.t("Submit Form")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                ref: recaptchaRef,
                sitekey: recaptchaClientKey,
                size: "invisible"
            }),
            linkedInConversionId && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                height: "1",
                width: "1",
                style: {
                    display: "none"
                },
                alt: "",
                src: "https://px.ads.linkedin.com/collect/?pid=2265524&conversionId=".concat(linkedInConversionId, "&fmt=gif")
            })
        ]
    });
};
/* harmony default export */ var Salesforce_SalesforceForm = (SalesforceForm);


/***/ }),

/***/ 84661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


const SkipSection = (param)=>{
    let { children , hrefs , style  } = param;
    const handleSpaceAndEnter = ()=>{
        for(let i = 0; i < hrefs.length; i += 1){
            const href = hrefs[i];
            const el = document.getElementById(href); // scroll to first element in hrefs found in DOM
            if (el) {
                window.location.href = "#".concat(href);
                el.focus();
                break;
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "pos-a-f bg-white gray800 ph4 pv3 br5 showOnFocus focus-bsDarkBlue3 brdn",
        style: style,
        onClick: handleSpaceAndEnter,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkipSection);


/***/ }),

/***/ 97455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _c10h_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45602);
/* harmony import */ var _components_SkipSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84661);
/* harmony import */ var ni18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96808);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40367);
/* harmony import */ var _hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33437);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57974);
/* harmony import */ var _common_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93932);
/* harmony import */ var _common_Carbon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29946);











const TestimonialSlider = (param)=>{
    let { defaultTestimons , defaultHead , autoRotate , firstBgColor , firstTextColor , smallFont =false , ariaLabel  } = param;
    const [k, setK] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0);
    const i18n = (0,ni18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { isMobile  } = (0,src_store__WEBPACK_IMPORTED_MODULE_4__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    (0,_common_Carbon__WEBPACK_IMPORTED_MODULE_8__/* .useInterval */ .Yz)(()=>{
        if ((autoRotate || isMobile) && !_common_constants__WEBPACK_IMPORTED_MODULE_7__/* .isCI */ .yg) {
            setK((k + 1) % testimons.length);
        }
    }, 8000, false);
    const head = defaultHead || i18n.t("What our patients say");
    const testimons = defaultTestimons || [
        {
            body: i18n.t("I highly recommend them to anyone needing medical attention. Reservations are easy to set up via their app and recommended to avoid wait time. Yelp only allows for 5 stars. I would give them a 10."),
            who: {
                name: "Gary",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: firstBgColor || _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint,
            color: firstTextColor || "#fff"
        },
        {
            body: i18n.t("Oh my God, finally an urgent care in our neighborhood that doesn't actually feel like an urgent care!  The space is super clean, modern, open and airy. The staff was excellent and were super friendly."),
            who: {
                name: "Gina",
                who: i18n.t("Carbon Health Los Angeles Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple,
            color: "#fff"
        },
        {
            body: i18n.t("If I could give this place 10 stars, I would. I received exceptional service from the moment I walked in, to the time I left. This place has been the best urgent care location I've ever been to."),
            who: {
                name: "Steph",
                who: i18n.t("Carbon Health San Jose Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        },
        {
            body: i18n.t("Literally amazing. They have the nicest doctors and staff, and you can get an appointment so easily and so fast! "),
            who: {
                name: "Liana",
                who: i18n.t("Carbon Health San Francisco Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkBlue
        },
        {
            body: i18n.t("Appreciated being seen immediately, the friendly and helpful staff, and my comprehensive care including x-rays, prescriptions called into my pharmacy and scheduling a follow-up appointment."),
            who: {
                name: "Laurie",
                who: i18n.t("Carbon Health Oakland Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerMint
        },
        {
            body: i18n.t("What I love is through their app (make sure you download the app - worth it) they check up on you to make sure you are ok. You are able to share any new developments."),
            who: {
                name: "Joeletta",
                who: i18n.t("Carbon Health Mountain View Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkPurple
        },
        {
            body: i18n.t("Great urgent care! Easy to make an appointment, got seen right away, the place was clean and tidy, and the staff was extremely friendly and helpful."),
            who: {
                name: "Tessa",
                who: i18n.t("Carbon Health Berkeley Patient")
            },
            bg: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerYellow
        }
    ];
    const activeItem = testimons[k];
    const swipeHandlers = (0,react_swipeable__WEBPACK_IMPORTED_MODULE_10__/* .useSwipeable */ .QS)({
        onSwipedRight: ()=>isMobile && changeSlide(-1),
        onSwipedLeft: ()=>isMobile && changeSlide(1)
    });
    const changeSlide = (val)=>{
        const nextVal = k + val > testimons.length - 1 ? 0 : k + val < 0 ? testimons.length - 1 : k + val;
        setK(nextVal);
    };
    const isXs = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("xs");
    const headingId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    const carouselId = (0,_hooks_useClientSideId__WEBPACK_IMPORTED_MODULE_5__/* .useClientSideId */ .i)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "lg:py-36 md:py-16 pt-16 pb-10 relative text-white contrast-tbt max-w-screen transition-colors duration-500",
        style: {
            backgroundColor: testimons[k].bg
        },
        "aria-labelledby": headingId,
        "aria-roledescription": "carousel",
        ...ariaLabel && {
            "aria-label": ariaLabel
        },
        ...swipeHandlers,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative m-auto px-4 md:px-24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SkipSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    hrefs: [
                        "explore-locations",
                        "footer"
                    ],
                    style: {
                        left: "2rem",
                        top: "-4rem"
                    },
                    children: i18n.t("Skip Carousel")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        !activeItem.hideHeadTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "font-ir fs13 op1 ls2 mb8 mt0 ttu",
                            id: headingId,
                            children: activeItem.head || head
                        }),
                        activeItem.headImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mb8 minh20",
                            children: activeItem.headImg
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative overflow-hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "transition-transform duration-500 grid grid-flow-col",
                                style: {
                                    gridAutoColumns: "100%",
                                    transform: "translateX(".concat(-100 * k, "%)")
                                },
                                id: carouselId,
                                "aria-live": autoRotate || isMobile ? "off" : "polite",
                                children: testimons.map((t, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                        className: "t-op200 pos-r df fdc op0 brdn pl0 m0 ".concat(i === k ? "op1" : ""),
                                        role: "group",
                                        "aria-label": i18n.t(" {{number}} of {{total}}", {
                                            number: i + 1,
                                            total: testimons.length
                                        }),
                                        "aria-hidden": i !== k,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-cm mb8 ".concat(smallFont ? "fs28 fs18-md" : "fs40 fs24-md", " lh12 lh14-md maxw64 pb24 pb16-md fx"),
                                                children: t.body
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md mb2",
                                                children: t.who.name
                                            }),
                                            t.who && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "font-cm fs20 fs18-md lh14 maxw12-md",
                                                children: t.who.who
                                            }),
                                            t.source && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: t.source,
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                                className: "white fs14 font-ir us pos-a",
                                                style: {
                                                    bottom: 0
                                                },
                                                children: i18n.t("Source")
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    ]
                }),
                testimons.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "df aic pos-a pos-r-xs mt4-xs",
                    style: isXs ? {} : {
                        right: "2rem",
                        bottom: isMobile ? ".25rem" : "-1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-mb fs12 mr6 ttu",
                            children: i18n.t(" {{number}} of {{total}}", {
                                number: k + 1,
                                total: testimons.length
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(-1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-left mr4 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Previous")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    style: {
                                        backgroundColor: _c10h_colors__WEBPACK_IMPORTED_MODULE_9__.darkerGreen + 33
                                    },
                                    onClick: ()=>changeSlide(1),
                                    className: "cp br50 p2 fs36 cIcon-arrow-right2 brdn white contrast-tb",
                                    "aria-controls": carouselId,
                                    "aria-label": i18n.t("Next")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TestimonialSlider);


/***/ }),

/***/ 46287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ carbon_for_campus; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/v5/TestimonialSlider.tsx
var TestimonialSlider = __webpack_require__(97455);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/_common/ImageItemList.tsx
var ImageItemList = __webpack_require__(36578);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/hooks/useFaqIndex.tsx + 2 modules
var useFaqIndex = __webpack_require__(47924);
;// CONCATENATED MODULE: ./src/constants/CarbonForCampus.tsx





const useCarbonForCampusConstants = ()=>{
    const faq = (0,useFaqIndex/* useFaqIndex */.l)([
        "How does partnering with Carbon Health healthcare lower costs?",
        "How do you ensure student satisfaction?",
        "Is Carbon Health HIPAA compliant?",
        "Is the Carbon Health app secure?",
        "What protections does Carbon have in place to protect my personal and health information from hackers or outsiders getting into the app or into their databases that store my information?"
    ]);
    const imageItems = [
        {
            header: src_i18n/* i18n.t */.ag.t("Comprehensive care"),
            content: src_i18n/* i18n.t */.ag.t("We offer a modern, flexible solution that integrates primary, urgent, and mental healthcare with nationwide virtual access to providers 7 days a week, 52 weeks a year."),
            image: {
                src: "/illustrations/doctor-and-patient",
                height: 125,
                alt: src_i18n/* i18n.t */.ag.t("Illustration of a doctor and patient discussing the patient’s care.")
            }
        },
        {
            header: src_i18n/* i18n.t */.ag.t("Flexible options"),
            content: src_i18n/* i18n.t */.ag.t("With our in-person clinics, extended hours, and desktop and mobile apps for virtual care, your students have easy access to high-quality healthcare, whether they’re on campus or learning remotely from a distance. "),
            image: {
                src: "reason/virtualCare/continuous",
                height: 125,
                alt: src_i18n/* i18n.t */.ag.t("Illustration of a young person wearing a face mask and making the peace sign with their hand.")
            }
        },
        {
            header: src_i18n/* i18n.t */.ag.t("Lower costs"),
            content: src_i18n/* i18n.t */.ag.t("Symptom management, continuous health monitoring, mental healthcare, and sexual health services can prevent emergencies and more-serious problems from developing down the line, lowering overall costs."),
            image: {
                src: "/illustrations/piggy-bank",
                height: 125,
                alt: src_i18n/* i18n.t */.ag.t("Illustration of a hand dropping a coin into a piggy bank.")
            }
        }
    ];
    const benefits = [
        {
            src: "/illustrations/mobile-app",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a cell phone"),
            header: src_i18n/* i18n.t */.ag.t("Comprehensive health services"),
            list: [
                src_i18n/* i18n.t */.ag.t("Primary & urgent care"),
                src_i18n/* i18n.t */.ag.t("Mental health services"),
                src_i18n/* i18n.t */.ag.t("Immunization management"),
                src_i18n/* i18n.t */.ag.t("Women's health"),
                src_i18n/* i18n.t */.ag.t("LGBTQ+ health"),
                src_i18n/* i18n.t */.ag.t("Sexual health")
            ],
            backgroundColor: palette.lightGreen,
            pattern: "0"
        },
        {
            src: "/illustrations/virtual-care",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a laptop"),
            header: src_i18n/* i18n.t */.ag.t("Increased access to healthcare"),
            list: [
                src_i18n/* i18n.t */.ag.t("Year-round care"),
                src_i18n/* i18n.t */.ag.t("Virtual visits & same-day appointments"),
                src_i18n/* i18n.t */.ag.t("Instant access to results and treatment plans in the app"),
                src_i18n/* i18n.t */.ag.t("Weekend and extended hours")
            ],
            backgroundColor: palette.lightBlue,
            pattern: "1"
        },
        {
            src: "/illustrations/syringe-and-vial",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a syringe and vial"),
            header: src_i18n/* i18n.t */.ag.t("Immunization management"),
            list: [
                src_i18n/* i18n.t */.ag.t("Digital immunization program"),
                src_i18n/* i18n.t */.ag.t("Immunization status reports"),
                src_i18n/* i18n.t */.ag.t("Vaccine schedule notifications"),
                src_i18n/* i18n.t */.ag.t("Health Pass digital vaccine card")
            ],
            backgroundColor: palette.lightYellow,
            pattern: "2"
        },
        {
            src: "/illustrations/doctor-and-patient",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a doctor and patient"),
            header: src_i18n/* i18n.t */.ag.t("Modern, high-quality clinics"),
            list: [
                src_i18n/* i18n.t */.ag.t("High-quality and professionally run clinics"),
                src_i18n/* i18n.t */.ag.t("Bright, airy spaces"),
                src_i18n/* i18n.t */.ag.t("Net Promoter Score (NPS) of 89"),
                src_i18n/* i18n.t */.ag.t("Holistic healthcare"),
                src_i18n/* i18n.t */.ag.t("Evidence-based medicine")
            ],
            backgroundColor: palette.lightRed,
            pattern: "3"
        },
        {
            src: "/illustrations/happy-healthy-person-smiling",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a patient receiving virtual care"),
            header: src_i18n/* i18n.t */.ag.t("Sexual health and wellness program"),
            list: [
                src_i18n/* i18n.t */.ag.t("STI evaluation and tests"),
                src_i18n/* i18n.t */.ag.t("Sexual health education"),
                src_i18n/* i18n.t */.ag.t("Risk assessment & prevention"),
                src_i18n/* i18n.t */.ag.t("Contraceptive options"),
                src_i18n/* i18n.t */.ag.t("Same-day access for sexual health issues")
            ],
            backgroundColor: palette.lightPurple,
            pattern: "4"
        },
        {
            src: "/illustrations/virus",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a virus molecule"),
            header: src_i18n/* i18n.t */.ag.t("Complete COVID-19 coverage"),
            list: [
                src_i18n/* i18n.t */.ag.t("Testing"),
                src_i18n/* i18n.t */.ag.t("Vaccine map"),
                src_i18n/* i18n.t */.ag.t("Health Pass digital vaccine card"),
                src_i18n/* i18n.t */.ag.t("COVID-Positive care program"),
                src_i18n/* i18n.t */.ag.t("Medical consultations"),
                src_i18n/* i18n.t */.ag.t("Enterprise dashboard with real-time reporting")
            ],
            backgroundColor: palette.mint,
            pattern: "5"
        }
    ];
    const data = [
        {
            header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Return to ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "darkerYellow",
                        children: "school safely"
                    })
                ]
            }),
            arrowStyle: {
                left: "30%",
                transform: "rotate(75deg)"
            },
            img: "/illustrations/person-in-chair-with-dog",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a person sitting in a comfy chair with their laptop, while their dog lays happily beside them."),
            list: [
                {
                    header: src_i18n/* i18n.t */.ag.t("Digital vaccine tracking program"),
                    text: src_i18n/* i18n.t */.ag.t("Our program registers students at the beginning of each term and collects their immunization info.")
                },
                {
                    header: src_i18n/* i18n.t */.ag.t("Real-time immunization status reports"),
                    text: src_i18n/* i18n.t */.ag.t("We make status reports available to student affairs administrators for decision-making. Students receive vaccine and immunization notifications, so you don’t have to send out reminders.")
                },
                {
                    header: src_i18n/* i18n.t */.ag.t("Health Pass: digital COVID-19 vaccine card"),
                    text: src_i18n/* i18n.t */.ag.t("Students can verify their vaccine status with our industry-leading, HIPAA-compliant digital vaccine card.")
                }
            ]
        },
        {
            header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Support for ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "darkerYellow",
                        children: "mental health"
                    })
                ]
            }),
            arrowStyle: {
                left: "35%",
                transform: "rotate(126deg)"
            },
            img: "/illustrations/person-in-virtual-care-session",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a person looking at their smart phone during a video call with their healthcare providers."),
            list: [
                {
                    header: src_i18n/* i18n.t */.ag.t("Comprehensive mental health services"),
                    text: src_i18n/* i18n.t */.ag.t("Our services are accessible to all students regardless of location — services include individual therapy, group therapy, and environmental response.")
                },
                {
                    header: src_i18n/* i18n.t */.ag.t("Customized response programs"),
                    text: src_i18n/* i18n.t */.ag.t("Carbon Health's clinical team will work with you to develop tailored programs in response to on-campus and global events.")
                },
                {
                    header: src_i18n/* i18n.t */.ag.t("Access to services from anywhere"),
                    text: src_i18n/* i18n.t */.ag.t("Carbon Health's comprehensive mental health services are accessible to all students regardless of location.")
                }
            ]
        },
        {
            header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                children: [
                    "Care ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "darkerYellow",
                        children: "when & where"
                    }),
                    " students need it"
                ]
            }),
            arrowStyle: {
                left: "5%",
                top: -70,
                transform: "rotateX(180deg) rotate(-80deg)"
            },
            img: "/illustrations/person-on-bike-with-phone",
            alt: src_i18n/* i18n.t */.ag.t("Illustration of a person standing with their bicycle, while looking at their phone."),
            list: [
                {
                    header: src_i18n/* i18n.t */.ag.t("Access from anywhere on any day"),
                    text: src_i18n/* i18n.t */.ag.t("We offer nationwide access to coverage 7 days a week, 52 weeks a year. Your remote and distributed students can get care virtually, or walk into any of 73 Carbon Health clinics in 10 states (soon to be 150 clinics around the country).")
                },
                {
                    header: src_i18n/* i18n.t */.ag.t("Chat with a provider from any device"),
                    text: src_i18n/* i18n.t */.ag.t("Our mobile apps are compatible with iOS and Android, and through the app you can chat with your provider, conduct virtual visits, and order prescription refills.")
                }
            ]
        }
    ];
    const ctaProps = {
        "aria-label": src_i18n/* i18n.t */.ag.t("Click to scroll to the contact form."),
        href: "#get-started",
        children: src_i18n/* i18n.t */.ag.t("Get Started")
    };
    const testimonials = [
        {
            body: src_i18n/* i18n.t */.ag.t("Carbon Health’s virtual and in-person offerings make it easy for students to keep in touch with their healthcare provider, make appointments, and access their medical records through the app."),
            bg: palette.darkerYellow,
            color: "#fff",
            who: {
                name: "Grace Hum",
                who: src_i18n/* i18n.t */.ag.t("Assistant Dean of Students at UC Hastings Law")
            }
        }
    ];
    return {
        faq,
        imageItems,
        benefits,
        data,
        ctaProps,
        testimonials
    };
};

// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/CarbonForCampus/About.tsx






const About = ()=>{
    const { imageItems , ctaProps  } = useCarbonForCampusConstants();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "about",
        className: "pv30 pb12-sm pt14-sm ph8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw80 ma",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "mb6 maxw52 fs40 fs28-sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "darkerYellow",
                                        children: "Carbon for Campus"
                                    }),
                                    " redefines the student health clinic to provide for all of your diverse, vibrant student population's on-campus and remote healthcare needs."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            ...ctaProps,
                            className: "focus-bsDarkBlue3"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageItemList/* ImageItemList */.T, {
                    itemClassName: "maxw22",
                    items: imageItems,
                    rows: 1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                    ...ctaProps,
                    className: "focus-bsDarkBlue3 dn-f db-f-sm"
                })
            ]
        })
    });
};
/* harmony default export */ var CarbonForCampus_About = (About);

// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
;// CONCATENATED MODULE: ./src/components/v5/CarbonForCampus/ColorCard.tsx





const ColorCard = (param)=>{
    let { src , alt , header , backgroundColor , list , pattern , className  } = param;
    const { imgExt  } = (0,store/* useTypedSelector */.ix)((state)=>state.config);
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pos-r ph8 pv8 pb20-xs br4 minh120 minh100-sm oh maxw28 maxw20-sm ".concat(className || ""),
        style: {
            backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pos-r zIndex1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
                        height: 80,
                        src: "".concat(src, ".").concat(imgExt),
                        alt: alt,
                        className: "mb4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "mb4 font-csb fs24 fs20-sm maxw16 lh15",
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "font-ir-sm fs14-sm fs18 lh15 ml7",
                        style: {
                            listStyle: "unset"
                        },
                        children: list.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: item
                            }, item))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
                src: "/paint-strokes/".concat(pattern, ".").concat(imgExt),
                className: "pos-a bottom0 left0",
                alt: i18n.t("Illustrated pattern")
            })
        ]
    });
};
/* harmony default export */ var CarbonForCampus_ColorCard = (ColorCard);

;// CONCATENATED MODULE: ./src/components/v5/CarbonForCampus/Benefits.tsx






const Benefits = ()=>{
    const { benefits , ctaProps  } = useCarbonForCampusConstants();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ph8 pt10 pb30",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw80 ma",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                        children: [
                            "Benefits of ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "darkerYellow",
                                children: "Carbon for Campus"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pv8 mb4 dg gg6 af df-sm fw",
                    children: benefits.map((b)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CarbonForCampus_ColorCard, {
                            ...b,
                            className: "mb3-sm"
                        }, b.header))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                    ...ctaProps,
                    className: "focus-bsDarkBlue3"
                })
            ]
        })
    });
};
/* harmony default export */ var CarbonForCampus_Benefits = (Benefits);

// EXTERNAL MODULE: ./src/components/v5/Salesforce/SalesforceForm.tsx + 1 modules
var SalesforceForm = __webpack_require__(29414);
;// CONCATENATED MODULE: ./src/components/v5/CarbonForCampus/Contact.tsx





const Contact = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "get-started",
        className: "bg-lightYellow pt30 pt14-sm pb80 pb20-xs ph8 pos-r",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "maxw80 ma df fdc-md zIndex1 pos-r",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fx df jcc mr8 mb10-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "maxw26",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "fs48 fs32-xs mb5 mb2-xs",
                                    children: i18n.t("Reach out, and let's get started")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "fs28 fs22-sm fs16-xs font-ir-xs font-cm",
                                    children: i18n.t("If you manage your students' health benefits and would like to learn more, please fill out the form, and we'll be in touch within one business day.")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fx df jcfe jcc-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bs2 hfc bg-white maxw28-sm maxw32 w100p",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SalesforceForm/* default */.Z, {
                                trackingCategory: "Carbon Ready",
                                trackingAction: "Enterprise Lead Form",
                                companyFieldLabel: i18n.t("Name of school campus"),
                                channel: "carbon-for-campus"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
                src: "/illustrations/squiggly-lines-yellow",
                className: "pos-a right0 bottom0 minh40-xs minw40-xs"
            })
        ]
    });
};
/* harmony default export */ var CarbonForCampus_Contact = (Contact);

// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
;// CONCATENATED MODULE: ./src/components/v5/CarbonForCampus/Hero.tsx







const Hero = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const isXs = (0,useMediaQuery/* default */.Z)("xs");
    const { ctaProps  } = useCarbonForCampusConstants();
    const backgroundPosition = isXs ? "50% 20%" : "30% 70%";
    const bgImg = "/_clinic_photos/a-clinic".concat(isXs ? "-mobile" : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* ImgWithBg */.Zx, {
        bgImage: bgImg,
        className: "minh140 pt58 pt24-xs pb100 pb120-xs ph8",
        style: {
            backgroundPosition
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "maxw80 ma",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "maxw32 maxw26-md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "mb2 font-csb fs48 fs40-md fs28-xs",
                        children: i18n.t("Bring high-quality care to your students")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb6 font-cm fs20 fs16-xs ls-3",
                        children: i18n.t("Carbon for Campus partners with colleges to offer comprehensive care, flexible options, and lower costs.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                href: "#about",
                                "aria-label": i18n.t("Click to scroll to the next section."),
                                className: "mr2 mb2 fs12-f-xs focus-bsDarkBlue3",
                                children: i18n.t("Learn More")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                ...ctaProps,
                                bg: palette.gray200,
                                hoverBg: palette.gray200,
                                color: palette.gray800,
                                className: "fs12-f-xs focus-bsDarkBlue3"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CarbonForCampus_Hero = (Hero);

// EXTERNAL MODULE: ./src/components/v5/IllustratedTextDecoration.tsx
var IllustratedTextDecoration = __webpack_require__(46452);
;// CONCATENATED MODULE: ./src/components/v5/CarbonForCampus/Overview.tsx








const Overview = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { data , ctaProps  } = useCarbonForCampusConstants();
    const isXs = (0,useMediaQuery/* default */.Z)("xs");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ph8 pt12 pb24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw80 ma",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "maxw30 mb4 fs40 fs32-xs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
                        children: [
                            "A healthcare program",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "darkerYellow",
                                children: [
                                    "tailored for",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "pos-r zIndex1",
                                        children: [
                                            "students",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustratedTextDecoration/* IllustratedTextDecoration */.S, {
                                                type: "yellow-underline",
                                                style: {
                                                    bottom: -5
                                                },
                                                className: "dn-xs"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "maxw40 font-cm dn-sm",
                    children: i18n.t("We understand that the needs of students differ from the needs of the general population. Our work with universities has allowed us to develop a uniquely student-centric program.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dg-xs gg6-xs",
                    children: data.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df fdc-sm mt40 mt0-xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "df fx jcc-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
                                        src: section.img,
                                        alt: section.alt,
                                        className: "h120 h100-md h72-sm"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "fx pos-r pt10",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Carbon/* V5Img */.fH, {
                                            src: "/illustrated-arrow-purple",
                                            className: "pos-a h18 w22 dn-sm",
                                            style: {
                                                top: -50,
                                                ...section.arrowStyle
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "fs28 fs20-xs font-cb",
                                            children: section.header
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "pl14 pl10-xs mt4",
                                            children: section.list.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: "pos-r mb6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "cIcon-illustrated-check pos-a fs22 fs16-xs",
                                                            style: {
                                                                left: isXs ? -32 : -50,
                                                                top: 3
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            className: "fs18 mb2 ls-3",
                                                            children: item.header
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "font-ir",
                                                            children: item.text
                                                        })
                                                    ]
                                                }, item.header))
                                        })
                                    ]
                                })
                            ]
                        }, section.img))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df fdc aic mt32 mt20-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs60 fs48-xs font-csb mb4",
                            children: i18n.t("We can help.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                            ...ctaProps,
                            className: "focus-bsDarkBlue3"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CarbonForCampus_Overview = (Overview);

// EXTERNAL MODULE: ./src/components/v5/Faq/Faq.tsx + 1 modules
var Faq = __webpack_require__(73349);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
;// CONCATENATED MODULE: ./src/pages/carbon-for-campus.tsx












const CarbonForCampus = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { faq , testimonials  } = useCarbonForCampusConstants();
    const pageTitle = "Carbon for Campus";
    const pageDescription = i18n.t("Carbon for Campus partners with colleges to offer comprehensive care, flexible options, and lower costs.");
    const ogAlt = i18n.t("Photo of a clinic lobby. It’s bright, clean, and modern, with colorful chairs and healthy plants.");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: pageTitle,
        pageDescription: pageDescription,
        pageImage: "carbon-for-campus-2",
        ogAlt: ogAlt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarbonForCampus_Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarbonForCampus_About, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarbonForCampus_Benefits, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarbonForCampus_Overview, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSlider/* default */.Z, {
                defaultTestimons: testimonials,
                defaultHead: i18n.t("What our clients say")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarbonForCampus_Contact, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq/* default */.Z, {
                faq: faq
            })
        ]
    });
};
/* harmony default export */ var carbon_for_campus = (CarbonForCampus);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9660,2745,3014,2493,4482,6282,2122,620,9774,2888,179], function() { return __webpack_exec__(52825); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);